"use client";

import { useEffect, useState, useCallback, useRef } from "react";

export interface ArticleRect {
  left: number;
  right: number;
  viewportWidth: number;
}

/**
 * article 요소의 뷰포트 기준 좌/우 위치를 추적합니다.
 * TOC, 필기, 학습경로 등 article 주변에 배치되는 고정 요소의 위치 계산에 사용됩니다.
 */
export function useArticleRect(): ArticleRect | null {
  const [rect, setRect] = useState<ArticleRect | null>(null);

  const rafRef = useRef(0);

  const update = useCallback(() => {
    cancelAnimationFrame(rafRef.current);
    rafRef.current = requestAnimationFrame(() => {
      const article = document.querySelector("article");
      if (article) {
        const r = article.getBoundingClientRect();
        const vw = window.innerWidth;
        setRect((prev) => {
          if (prev && prev.left === r.left && prev.right === r.right && prev.viewportWidth === vw) return prev;
          return { left: r.left, right: r.right, viewportWidth: vw };
        });
      }
    });
  }, []);

  useEffect(() => {
    update();
    // 레이아웃 안정화 후 재확인 (광고 로딩 등)
    const timer = setTimeout(update, 1000);
    window.addEventListener("resize", update);
    return () => {
      clearTimeout(timer);
      cancelAnimationFrame(rafRef.current);
      window.removeEventListener("resize", update);
    };
  }, [update]);

  return rect;
}
